import { toCanonicalSaleStatus, type CanonicalSaleStatus } from '~/constants/properties';

type StagedProperty = { status?: string | null; sales_status?: { en?: string | null } | null };

// Card stage pill from the sale status code the Stage filter matches on; the English label is a fallback.
export const projectStageLabel = (property: StagedProperty | null | undefined): CanonicalSaleStatus | '' =>
  toCanonicalSaleStatus(property?.status) || toCanonicalSaleStatus(property?.sales_status?.en);
